import { Close } from "@mui/icons-material";
import {
  Box,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { getBillingEntity } from "api/services/billingEntity";
import { logo } from "assets";
import Loader from "components/Loader";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import {
  handleApprovalChange,
  handleBillingEntityChange,
  handleFieldChange,
  handleUpdateTermsAndConditions,
  selectEstimate,
} from "redux/reducers/createEstimateSlice";
import { ResType } from "types";
import { StyledSelectedBox } from "pages/billing/styles";
import SectionHeading from "../SectionHeading";
import { placeOfSupplyStates } from "data/placeOfSupply";

function BillingEntityDetails({ result }) {
  // const { billingEntityAddress, approvalHierarchy, billingEntity } = result;
  const { billingEntityAddress, approvalHierarchy, billingEntity, locationOfSupply, hasGst } =
    useSelector(selectEstimate);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const [gstNumber, setGstNumber] = useState('NA');
  const { data, isLoading }: ResType = useQuery(
    ["billing-entities"],
    getBillingEntity, {
    onSuccess: (res: any) => {
      if (result?.billingEntity && result?.billingEntity.tradeName !== '') {
        dispatch(handleBillingEntityChange({ billingEntity: result?.billingEntity }));
        dispatch(handleFieldChange({ key: 'hasGst', value: result.billingEntity?.hasGst }));
        dispatch(handleFieldChange({ key: 'createdAt', value: result.createdAt }));
        if (result?.billingEntity?.locationOfSupply) {
          const locationOfSupply = placeOfSupplyStates.find(
            (o: any) => o.split('-')[1] === result?.billingEntity?.locationOfSupply
          ) || "NA";
          dispatch(handleFieldChange({ key: "locationOfSupply", value: locationOfSupply }));
        };
        if (result?.billingEntity?.creditPeriod) {
          dispatch(handleFieldChange({ key: "terms", value: result?.billingEntity?.creditPeriod }));
        }
        setGstNumber(result?.billingEntity?.gstNumber || "NA");

      }
    },
  }
  );


  if (isLoading) return <Loader />;

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Box>
            <TextField
              select
              label="Billing Entity"
              fullWidth
              size="small"
              name="billingEntity"
              disabled
              value={billingEntity || ''}
            >
              {data?.data?.map((item: any, index: number) => (
                <MenuItem value={item?.id} key={index}>
                  {item?.tradeName}
                </MenuItem>
              ))}
            </TextField>
            <Box mt={2}>
              <SectionHeading title="Organisation Billing Information" />
              <Box p={2}>
                {/* <Box mb={1}>
                  <img src={logo} alt="logo" />
                </Box> */}
                <AddressDetail
                  title="Trade Name"
                  value={billingEntityAddress?.legalName}
                />
                <AddressDetail
                  title="Address"
                  value={getAddress(billingEntityAddress)}
                />
                {billingEntityAddress?.mobileNumber && <AddressDetail
                  title="Mobile Number"
                  value={billingEntityAddress?.mobileNumber}
                />}
                {billingEntityAddress?.email && <AddressDetail
                  title="Email ID"
                  value={billingEntityAddress?.email}
                />}
                {result?.billingEntity?.hasGst &&
                  <AddressDetail
                    title="PAN"
                    value={gstNumber.slice(2, -3)}
                  />
                }
                {(!result?.billingEntity?.hasGst && result?.billingEntity?.panNumber) &&
                  <AddressDetail
                    title="PAN"
                    value={result?.billingEntity?.panNumber}
                  />
                }
                {result?.billingEntity?.hasGst &&
                  <AddressDetail
                    title="GSTIN"
                    value={gstNumber}
                  />
                }
                {result?.billingEntity?.hasGst &&
                  <AddressDetail
                    title="Location of Supplier"
                    value={locationOfSupply}
                  />
                }
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={6}>
          {approvalHierarchy ? (
            <StyledSelectedBox sx={{ mt: 0 }}>
              <Box display="flex" gap={1} alignItems="center">
                <Typography variant="caption">Approval Hierarchy -</Typography>
                <Typography variant="subtitle2">
                  {approvalHierarchy?.name}
                </Typography>
              </Box>
              <IconButton
                onClick={() => dispatch(handleApprovalChange(null))}
                size="small"
              >
                <Close fontSize="small" />
              </IconButton>
            </StyledSelectedBox>
          ) : (
            <></>
            // <StyledSelectBox sx={{ mt: 0 }} onClick={() => setOpen(true)}>
            //   <Typography>+ Select Approval Hierarchy</Typography>
            // </StyledSelectBox>
          )}
        </Grid>
      </Grid>
    </>
  );
}

export const AddressDetail = ({ title, value }) => {
  return (
    <Box sx={{ marginBottom: "16px" }}>
      <Grid container>
        <Grid item xs={4}>
          <Typography variant="body1">{title}</Typography>
        </Grid>
        <Grid item xs={1}>
          <span>:</span>
        </Grid>
        <Grid item xs={7}>
          <Typography variant="h6" sx={{ flex: 2 }}>
            {value}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export let getAddress = (address: any) => {
  let result = "";
  if (address?.buildingNumber) {
    result += `${address?.buildingNumber}, `;
  }
  if (address?.floorNumber) {
    result += `${address?.floorNumber}, `;
  }
  if (address?.buildingName) {
    result += `${address.buildingName}, `;
  }
  if (address?.street) {
    result += `${address.street}, `;
  }
  if (address?.location) {
    result += `${address.location}, `;
  }
  if (address?.city) {
    result += `${address.city}, `;
  }
  if (address?.district) {
    result += `${address.district}, `;
  }
  if (address?.state) {
    result += `${address.state} - `;
  }
  if (address?.pincode) {
    result += address.pincode;
  }
  return result;
};

export default BillingEntityDetails;
